import React from 'react'

var Loading =  React.createContext()
var LoadingDispatch =  React.createContext()

function loadReducer(state, action){
	switch (action.type) {
		case true:
			return { ...state, load: true}
		case false:
			return { ...state, load: false}
		default : {
			throw new Error(`Unhandled action type: ${action.type}`)
		}
	}
}

function LoadingProvider({ children }) {
	var [state, dispatch] = React.useReducer(loadReducer, {
		load: true,
	})

	return (
		<Loading.Provider value={state}>
			<LoadingDispatch.Provider value={dispatch}>
				{children}
			</LoadingDispatch.Provider>
		</Loading.Provider>
	)
}

function useLoadState() {
	var context = React.useContext(Loading)
	if (context === undefined) {
		throw new Error('useLoadState must be used within a UserProvider')
	}
	return context
}

function useLoadDispatch() {
	var context = React.useContext(LoadingDispatch)
	if (context === undefined) {
		throw new Error('useLoadDispatch must be used within a UserProvider')
	}
	return context
}

function setLoading(dispatch, loading){
	dispatch({type:loading})
}

export {LoadingProvider, useLoadState, useLoadDispatch, setLoading}